export default {
    name: "SettingsPropertyTab",

    props: {
        tariff_rows: {
            type: Array,
            default: () => []
        },
        get_assignment_date_range: {
            type: Function,
            required: true
        }
    },

    emits: [
        "add-tariff",
        "view-rates",
        "edit-assignment"
    ]
};
